// helpers
import { readCookie, writeCookie, deleteCookie } from "core/cookieKeys.js";

// data
import { SITE_HEADER_COOKIES } from "core/cookieKeys.js";
const { HIDE_MARKETING_MESSAGE_BELL } = SITE_HEADER_COOKIES;

/**
 * Currently we are relying on FE to handle Marketing Message Bell Display
 * Bell shows by default. After user sees message (opens/closes modal)
 * we hide the bell. Also setting in localStorage so they do not
 * see the Bell going forward
 */
export const enableBellNotifications = () => {
    deleteCookie(HIDE_MARKETING_MESSAGE_BELL);
};

export const disableBellNotifications = () => {
    writeCookie({ name: HIDE_MARKETING_MESSAGE_BELL, value: true });
};

export const getHideBellNotification = (ssrCookies = {}) => {
    const cookieValue = ssrCookies[HIDE_MARKETING_MESSAGE_BELL]
        ? ssrCookies[HIDE_MARKETING_MESSAGE_BELL]
        : readCookie(HIDE_MARKETING_MESSAGE_BELL);

    return cookieValue === true;
};

export const scrollWindowTo = distance => {
    window.scrollTo({ top: distance, behavior: "smooth" });
};
